<template>
  <nav>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="edit-default-language-button"
          v-bind="attrs"
          icon
          absolute
          right
          top
          class="mt-n2 mr-n2"
          v-on="on"
          @click="$emit('proceedSubmit', '', '')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card data-testid="edit-default-language-card">
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="updateSpaceName"
          @submit.prevent
        >
          <v-toolbar
            dark
            color="accent"
          >
            <v-btn
              data-testid="close-button"
              icon
              dark
              @click="reloadForm"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h5 font-weight-bold">
              {{ $t('editDefaultLanguageTitle') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              data-testid="submit-button"
              type="submit"
              :disabled="loading"
              color="white"
              class="text-body-1 darktext--text text-none rounded-xxl px-4"
              @click="updateDefaultLanguage"
            >
              {{ $t('save') }}
            </v-btn>
          </v-toolbar>
          <AlertMessages
            v-if="alertValue"
            alert-type="error" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
          />
          <v-card-text class="pt-0 pl-6"> 
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="py-15 px-md-12">
                  <p class="font-weight-bold text-h6 darktext--text">
                    {{ $t('labelDefaultLanguage') }}
                  </p>
                  <v-card-text class="pt-0 pl-6">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="">
                  <v-radio-group v-model="language">
                    <v-radio
                      v-for="option in languageOptions"
                      :key="option.id"
                      data-testid="language-input"
                      :value="option.id"
                      color="accent"
                      class="black--text"
                    >
                      <template slot="label">
                        <span>
                          {{ $t(option.language) }}
                        </span>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { updateSpace } from '../../api/spaceApi'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    data(){
        return{
            dialog: false,
            valid: true,
            alertMsg: '',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loading: false,
            languageOptions: [{'id': 'en', 'language': 'english'}, {'id': 'sv', 'language': 'swedish'}, {'id': 'mk', 'language': 'macedonian'}],
            language: localStorage.space ? JSON.parse(localStorage.space).language : '',
         }
    },
    
    methods: {
        async updateDefaultLanguage(){
              this.$refs.form.validate()
            if(this.valid){
                this.loading = true
                var alertType = ''
                var alertMsg = ''
                try {
                    let data = {
                        data: {
                            type: "spaces", 
                            id: this.spaceId,
                            attributes: {
                                language: this.language
                            }
                        }
                    };
                    const response = await updateSpace(this.spaceId, data)
                    if(response.status == 200) {
                        alertMsg =  i18n.t('editDefaultLanguageSuccess')
                        alertType = 'success'
                        localStorage.space = JSON.stringify(response.data.data.attributes)
                        this.$emit('proceedSubmit', alertMsg, alertType)
                        this.reloadForm()
                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                            alertType = 'error'
                            alertMsg =  i18n.t('serverError')
                            this.$emit('proceedSubmit', alertMsg, alertType)
                            this.reloadForm()
                    }
                }
                this.loading = false
            }
        },
        reloadForm(){
            this.dialog = false,
            this.alertMsg = '',
            this.language = localStorage.space ? JSON.parse(localStorage.space).language : ''
        }
    }
}
</script>